<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        {{datasetTypeDisplayName}}
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">{{datasetTypeDisplayName}}</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="action-button pull-right">

              <label for="file-upload" class="custom-file-upload">
                <p class="btn btn-primary btn-import-dataset"> <i class="fa fa-upload" aria-hidden="true"></i> Import Dataset</p>
              </label>
              <input id="file-upload" type="file"  @change="onImportClick" accept=".csv">

              </div>
              <div class="col-xs-12 col-md-12 col-lg-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="auditDataSet"
                    :totalRows="auditDataSetCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: 15,
                        perPageDropdown: [10, 15, 20, 50, 100]
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-database" title="No datasets found" hint="Import a dataset to start auditing, or change the filters." /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'importedAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'audit'">
                          <router-link :to="`audit/${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'evaluate'">
                          <router-link :to="`evaluate/${props.row.id}`">
                            <i class="fa fa-calculator" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'export'" @click="exportDataSet(props.row.id)" id='download-link'>
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </span>
                        <span v-else-if="props.column.field == 'delete'" @click="showDeleteDatasetModel(props.row.id)" id='delete-link'>
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
              </div>

                  <div class="modal-backdrop" v-if="isGenderSplitModel" id="translate">
                    <div class="modal modal-md" style="height: 260px;max-width:600px">
                      <div class="modal-header">
                        <slot name="header">
                          <h3>Apply sampling on data set (Optional)</h3>
                        </slot>
                      </div>
                        <div style="margin: 0px 20px; font-size:18px; text-align: justify;">
                          <slot name="body">
                            <div>Are you interested in applying gender-based sampling to the uploaded data? This can aid in downstream data analysis and lead to improved evaluation.</div>
                          </slot>
                        </div>

                        <div class="modal-footer" style="margin-top: auto; padding: 0px">
                          <div class="form-group pull-right">
                            <div class="col-sm-12">
                              <button type="button" class="btn btn-primary" @click="closeGenderSplitModel">Cancel</button>
                              <button type="button" class="btn btn-primary" @click="showSplitSelectModel">Choose sampling</button>
                              <button type="button" class="btn btn-primary" @click="uploadFileData">Skip & Import Dataset</button> 
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>


                  <div class="modal-backdrop" v-if="isSplitSelectModel" id="translate">
                    <div class="modal modal-md" style="height: 260px;max-width:600px">
                      <div class="modal-header">
                        <slot name="header">
                          <h3>Select sampling percentage</h3>
                        </slot>
                      </div>
                        <div style="margin: 0px 20px; overflow-y: auto; overflow-x: hidden; height: 100%;font-size:20px;">
                          <slot name="body">

                            <div style="margin-bottom:10px; font-size:18px">
                              <slot name="body">
                                <div>Please choose the percentage split between gender by using slider:</div>
                              </slot>
                            </div>

                            <div class="form-horizontal">
                                <div class="">
                                  <label for="inputRange" style="width: 100%">
                                    <span>Women: {{slideInput}}%</span>
                                    <span class="pull-right">Men: {{100-slideInput}}%</span>
                                  </label>
                                  <input type="range" v-model="slideInput" class="form-control-range" id="slideInput" max="100" min="0">
                                </div>
                            </div>
                          </slot>
                        </div>
                        <div class="modal-footer" style="margin-top: auto; padding: 0px">
                          <div class="form-group pull-right">
                                <div class="col-sm-12">
                                  <button type="button" class="btn btn-primary" @click="closeSplitSelectModel">Cancel</button>
                                  <button type="button" class="btn btn-primary" @click="showGenderSplitModel">Go to previous step</button>
                                  <button type="button" class="btn btn-primary" @click="uploadFileData(slideInput)">Import Dataset</button> 
                                </div>
                              </div>
                        </div>
                    </div>
                  </div>


                  <div class="modal-backdrop" v-if="isDeleteDatasetModel" id="translate">
                    <div class="modal modal-md" style="height: 200px;max-width:600px">
                      <div class="modal-header">
                        <slot name="header">
                          <h3>Delete Dataset</h3>
                        </slot>
                      </div>
                        <div style="margin: 0px 20px; font-size:18px; text-align: justify;">
                          <slot name="body">
                            <div>Are you sure you want to permanently delete the dataset?</div>
                          </slot>
                        </div>

                        <div class="modal-footer" style="margin-top: auto; padding: 0px">
                          <div class="form-group pull-right">
                            <div class="col-sm-12">
                              <button type="button" class="btn btn-primary" @click="closeDeleteDatasetModel">Cancel</button>
                              <button type="button" class="btn btn-primary btn-danger" @click="deleteDataSet">Delete</button> 
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>

            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>
</template>

<script>
import api from '../../../utils/api'
import { formatDate, getSelectorValue } from '../../../utils/utilities'
import moment from 'moment'
import flatPickr from 'flatpickr'
import { getDatasetDisplayType } from './helpers'
import 'flatpickr/dist/flatpickr.css'
export default {
  name: 'auditing',
  components: {
    flatPickr
  },
  data () {
    return {
      slideInput: 50,
      datasetType: '',
      datasetTypeDisplayName: '',
      isGenderSplitModel: false,
      isSplitSelectModel: false,
      isDeleteDatasetModel: false,
      deleteDatasetId: null,
      files: null,
      formatDate: formatDate,
      loading: true,
      auditDataSet: [],
      auditDataSetCount: 0,
      tableQueryParams: {
        columnFilters: {},
        sort: {
          importedAt: 'desc'
        },
        page: 1,
        perPage: 15
      },
      previousQueryParams: {},
      columns: [
        {
          label: 'Data set',
          field: 'fileName',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search data set'
          }
        },
        {
          label: 'Imported On',
          field: 'importedAt',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Women Count',
          field: 'womenCount',
          sortable: false
        },
        {
          label: 'Men Count',
          field: 'menCount',
          sortable: false
        },
        {
          label: 'Audit',
          field: 'audit',
          sortable: false
        },
        {
          label: 'Evaluate',
          field: 'evaluate',
          sortable: false
        },
        {
          label: 'Export',
          field: 'export',
          sortable: false
        },
        {
          label: 'Delete',
          field: 'delete',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.$route.path) {
      this.datasetType = this.$route.path.split('/').pop()
      this.datasetTypeDisplayName = getDatasetDisplayType(this.datasetType)
    }
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true,
      onClose: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          instance.setDate([selectedDates[0], selectedDates[0]], true)
        }
      }
    })
    this.listDataSet()
  },
  methods: {
    onImportClick (event) {
      this.files = event.target.files
      this.showGenderSplitModel()
    },
    closeGenderSplitModel () {
      this.isGenderSplitModel = false
    },
    showGenderSplitModel () {
      this.isGenderSplitModel = true
      this.isSplitSelectModel = false
    },
    uploadFileData (value) {
      this.isGenderSplitModel = false
      this.isSplitSelectModel = false
      if (value || value === 0) {
        this.uploadFile(`?men=${100 - Number(value)}&women=${Number(value)}`)
      } else this.uploadFile()
    },
    showSplitSelectModel () {
      this.isGenderSplitModel = false
      this.isSplitSelectModel = true
    },
    closeSplitSelectModel () {
      this.isSplitSelectModel = false
    },
    showDeleteDatasetModel (value) {
      this.deleteDatasetId = value
      this.isDeleteDatasetModel = true
    },
    closeDeleteDatasetModel () {
      this.isDeleteDatasetModel = false
    },
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.listDataSet()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.listDataSet()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType
        }
      })
      this.listDataSet()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (key === 'importedAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.listDataSet()
    },
    /**
     * @function listDataSet
     * @description Get listDataSet from api
     */
    uploadFile (qryparams = '') {
      this.loading = true
      const formData = new FormData()
      formData.append('audit-data-set', this.files[0])
      api.buildRequest(`audit/import/${this.datasetType}${qryparams}`, 'POST', formData)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.$swal({
              type: 'success',
              text: 'File uploaded successfully'
            })
            console.log('list data set')
            this.listDataSet(true)
          } else {
            this.$swal({
              type: 'error',
              text: response.data.payload.error || response.data.payload.message || 'An error occurred'
            })
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    exportDataSet (dataSetId) {
      console.log('event2 ', dataSetId)
      this.loading = true
      api.buildRequest(`audit/export/${dataSetId}`, 'GET')
          .then(response => {
            console.log('response: ', response)
            this.loading = false
            const contentDisposition = response.headers['content-disposition']
            const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/)
            const fileName = fileNameMatch ? fileNameMatch[1] : 'file.csv'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
          }).catch(error => {
            this.loading = false
            console.log('error: ', error)
            this.$swal({
              type: 'error',
              text: error.response ? error.response.data.payload.message : 'An error occurred'
            })
          })
    },
    deleteDataSet () {
      console.log('event2 ', this.deleteDatasetId)
      this.loading = true
      this.isDeleteDatasetModel = false
      api.buildRequest(`audit/audit-data-set/${this.deleteDatasetId}`, 'DELETE')
          .then(response => {
            this.loading = false
            this.$swal({
              type: 'success',
              text: 'File deleted successfully'
            })
            this.listDataSet(true)
          }).catch(error => {
            this.loading = false
            console.log('error: ', error)
            this.$swal({
              type: 'error',
              text: error.response ? error.response.data.payload.message : 'An error occurred'
            })
          })
    },
    getSelector (selector) {
      for (const [key, value] of Object.entries(selector)) {
        selector[key] = value.replace(/'/g, "''")
      }
      return selector
    },
    listDataSet (forceLoadData = false) {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (!forceLoadData && JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams)) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }

      api.buildRequest(`/audit/list/${this.datasetType}`, 'POST', queryParams)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.previousQueryParams = queryParams
              this.auditDataSet = response.data.payload.auditDataSet
              this.auditDataSetCount = response.data.payload.auditDataSetCount
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    }
  }
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
input[type="file"] {
  display: none;
}
.box-body {
  min-height: calc(100vh - 171px);
}
.form-loader img {
  width: 30px;
  height: 30px;
}
.btn-import-dataset {
  margin-bottom: 15px;
  margin-right: 15px;
}
input[type='range'] {
  overflow: hidden;
  -webkit-appearance: none;
  background-color: lightblue;
  border-radius: 10px;
}

input[type='range']::-webkit-slider-runnable-track {
  height: 25px;
  -webkit-appearance: none;
  color: #13bba4;
}

input[type='range']::-webkit-slider-thumb {
  width: 10px;
  -webkit-appearance: none;
  height: 40px;
  cursor: ew-resize;
  background: black;
  box-shadow: -600px 0 0 600px pink;
}  
/** FF*/
input[type="range"]::-moz-range-progress {
  background-color: pink; 
}
input[type="range"]::-moz-range-track {  
  background-color: lightblue;
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: pink; 
}
input[type="range"]::-ms-fill-upper {  
  background-color: lightblue;
}
</style>


// WEBPACK FOOTER //
// index.vue?146e553f